import { render } from "./ComboCidade.vue?vue&type=template&id=202a461c&ts=true"
import script from "./ComboCidade.vue?vue&type=script&lang=ts"
export * from "./ComboCidade.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__